import React, {useEffect, useState} from 'react'
import {NavLink, useLocation} from "react-router-dom";
import SidebarMenu from "./SidebarMenu";
import {resolveWhiteLabelTheme} from "../config/whiteLabelThemes";

const HIDE_LOGO_SESSION_KEY = 'front.hideLogo'

const Header = () => {

    const [sidebarOpen ,setSidebarOpen] = useState(false)
    const {search} = useLocation()
    const hideLogoFromQuery = new URLSearchParams(search).get('hideLogo') === 'true'
    const hideLogoFromSession = typeof window !== 'undefined' &&
        window.sessionStorage &&
        window.sessionStorage.getItem(HIDE_LOGO_SESSION_KEY) === 'true'
    const hideLogo = hideLogoFromQuery || hideLogoFromSession
    const whiteLabelTheme = resolveWhiteLabelTheme()
    const logoSrc = whiteLabelTheme.logoSrc
    const logoHref = whiteLabelTheme.logoHref || "/"
    const logoAlt = whiteLabelTheme.logoAlt || "NewWay Car Rental"
    const isExternalLogoHref = /^https?:\/\//i.test(logoHref)

    useEffect(() => {
        if (hideLogoFromQuery && typeof window !== 'undefined' && window.sessionStorage) {
            window.sessionStorage.setItem(HIDE_LOGO_SESSION_KEY, 'true')
        }
    }, [hideLogoFromQuery])

    return (
        <header className={`front-header${hideLogo ? ' front-header--brand-only' : ''}`}>

            {
                sidebarOpen && !hideLogo && (
                    <SidebarMenu />
                )
            }



            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-3 col-md-12 front-header-logo-container">
                        {
                            isExternalLogoHref ? (
                                <a href={logoHref} target="_top" rel="noreferrer">
                                    <img className="front-header-logo" src={logoSrc} alt={logoAlt}/>
                                </a>
                            ) : (
                                <NavLink to={logoHref} end>
                                    <img className="front-header-logo" src={logoSrc} alt={logoAlt}/>
                                </NavLink>
                            )
                        }
                        {
                            !hideLogo && (
                                <div className="front-header-burger" onClick={() => setSidebarOpen(!sidebarOpen)}>
                                    {
                                        !sidebarOpen ?
                                            <i className="bi bi-list"></i>
                                            :
                                            <i className="bi bi-x-lg"></i>
                                    }
                                </div>
                            )
                        }
                    </div>
                    <div className="col-md-9 front-header-nav-column">
                        <nav className="front-header-nav">
                            <NavLink to="/backoffice" className="front-header-link">
                                Aanbod
                            </NavLink>
                            <NavLink to="/backoffice" className="front-header-link">
                                Vestigingen
                            </NavLink>
                            <NavLink to="/voor-verhuurbedrijven" className="front-header-link">
                                Voor verhuurbedrijven
                            </NavLink>
                            <NavLink to="/voor-particulieren" className="front-header-link">
                                Voor particulieren
                            </NavLink>
                            <NavLink to="/backoffice" className="front-header-link">
                                Huren per uur
                            </NavLink>
                            <NavLink to="/backoffice" className="front-header-link">
                                Over KAV2GO
                                <i className="bi bi-chevron-down ms-2" aria-hidden="true"/>
                            </NavLink>
                            <div>
                                <i className="bi bi-search" aria-hidden="true"/>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>


        </header>
    )
}

export default Header
